module.exports = __webpack_public_path__ + "static/media/mira_community_header_bg_tiles.0436309d.png";